export { default } from "./ClosetItemsList";
